import { render, staticRenderFns } from "./_Auth.vue?vue&type=template&id=07c6d8b9"
import script from "./_Auth.vue?vue&type=script&lang=js"
export * from "./_Auth.vue?vue&type=script&lang=js"
import style0 from "./_Auth.vue?vue&type=style&index=0&id=07c6d8b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports